"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Keys;
(function (Keys) {
    Keys[Keys["ArrowUp"] = 0] = "ArrowUp";
    Keys[Keys["ArrowDown"] = 1] = "ArrowDown";
    Keys[Keys["ArrowLeft"] = 2] = "ArrowLeft";
    Keys[Keys["ArrowRight"] = 3] = "ArrowRight";
    Keys[Keys["Enter"] = 4] = "Enter";
    Keys[Keys["Escape"] = 5] = "Escape";
    Keys[Keys["Alt"] = 6] = "Alt";
    Keys[Keys["Control"] = 7] = "Control";
    Keys[Keys["Home"] = 8] = "Home";
    Keys[Keys["End"] = 9] = "End";
    Keys[Keys["PageDown"] = 10] = "PageDown";
    Keys[Keys["PageUp"] = 11] = "PageUp";
    Keys[Keys["Backspace"] = 12] = "Backspace";
    Keys[Keys["Delete"] = 13] = "Delete";
    Keys[Keys["Tab"] = 14] = "Tab";
})(Keys = exports.Keys || (exports.Keys = {}));
function isKey(key, keyboardEvent) {
    if (Keys[keyboardEvent] === key) {
        return true;
    }
    switch (keyboardEvent) {
        case Keys.ArrowUp:
            return key === "Up";
        case Keys.ArrowDown:
            return key === "Down";
        case Keys.ArrowLeft:
            return key === "Left";
        case Keys.ArrowRight:
            return key === "Right";
        case Keys.Escape:
            return key === "Esc";
        default:
            return false;
    }
}
exports.isKey = isKey;
